import { StyleSheet, Dimensions } from 'react-native'
import theme from '../../../theme'

const { width } = Dimensions.get('window')

const styles = StyleSheet.create({
    container: {
        flex: 1,
    },
    containerSection: {
        flexDirection: 'row',
        marginHorizontal: 12,
        marginVertical: 10,
        marginBottom: 10,
    },
    section: {
        fontSize: 18,
        fontWeight: 'normal',
        color: theme.colors.textSecondary,
        fontWeight: 'bold',
    },
    triviaItem: {
        padding: 10,
        flexDirection: 'row',
        justifyContent: 'space-between',
    },
    triviaImage: {
        width: 80,
        marginRight: 10,
        aspectRatio: 1,
        alignSelf: 'flex-start',
        marginTop: 1,
        borderRadius: 5,
    },
    triviaName: {
        fontSize: 15,
        marginBottom: 2,
        fontWeight: 'bold',
        color: theme.colors.textPrimary,
        paddingRight: 15,
    },
    triviaDescription: {
        fontSize: 13,
        marginBottom: 11,
        fontWeight: 'normal',
        color: theme.colors.textSecondary,
        paddingRight: 10,
    },
    justifyCenter: {
        justifyContent: 'center',
        alignSelf: 'flex-start',
        marginTop: 1,
    },
    status: {
        fontSize: 12,
        fontWeight: 'bold',
        textTransform: 'uppercase',
        textAlign: 'center',
        paddingHorizontal: 2,
        paddingVertical: 3,
        borderRadius: 5,
        overflow: 'hidden',
        alignItems: 'center',
    },
    dividerHorizontalLine: {
        flex: 1,
        borderBottomWidth: 0.5,
        borderBottomColor: theme.colors.lightGray,
        marginVertical: 5,
        marginHorizontal: 2,
    },
    image: {
        width: 140,
        height: 140,
    },
    title: {
        fontSize: 20,
        fontWeight: 'bold',
        color: theme.colors.textPrimary,
        textAlign: 'center',
        marginBottom: 6,
    },
    description: {
        fontSize: 17,
        fontWeight: 'normal',
        color: theme.colors.textSecondary,
        textAlign: 'center',
        lineHeight: 23,
        paddingHorizontal: 10,
    },
    scrollView: {
        flexDirection: 'row',
        flexGrow: 0,
    },
    spacer: {
        height: 84,
    },
    spacerBis: {
        marginTop: 175,
    },
    noTrivia: {
        fontSize: 18,
        fontWeight: 'bold',
        color: theme.colors.textSecondary,
        textAlign: 'center',
        borderRadius: 20,
        backgroundColor: theme.colors.lightGray,
        padding: 10,
    },
    containerNoTrivia: {
        flex: 1,
        justifyContent: 'center',
        alignItems: 'center',
    },
    imageNoTrivia: {
        width: 160,
        height: 160,
        resizeMode: 'contain',
        marginVertical: 5,
        marginBottom: 5,
    },
    title2: {
        fontSize: 18,
        fontWeight: 'bold',
        color: theme.colors.textPrimary,
        textAlign: 'center',
        marginBottom: 1,
    },
    description2: {
        fontSize: 17,
        color: theme.colors.textSecondary,
        textAlign: 'center',
        lineHeight: 23,
        marginBottom: 1,
    },
    description3: {
        fontSize: 17,
        fontWeight: 'normal',
        color: theme.colors.textSecondary,
        textAlign: 'center',
        lineHeight: 23,
        marginBottom: 1,
    },
})

export default styles
